module.exports = __webpack_public_path__ + "media/images/tunisie-aecb4d3efaec7d432605fef01f383d24.svg";